import { Suspense } from 'react'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { LayoutPage } from '@/components/layout/page'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { UsageFallback } from '@/routes/usage/fallback'
import { UsageContent } from '@/routes/usage/usage-content'

export const UsagePage = () => {
  const { idCompany } = useIdCompany()
  const { rbac } = useRBAC()

  rbac.company(idCompany).usage.view.ensure()

  return (
    <LayoutPage browserTitle="Usage" fallback={<CardSkeleton />}>
      <div className="pb-25">
        <Suspense fallback={<UsageFallback />}>
          <UsageContent />
        </Suspense>
      </div>
    </LayoutPage>
  )
}
